import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Text } from '../../../atoms';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import SessionBox from './SessionBox';
import QuizBox from './QuizBox';
import { MODAL_OPEN } from '../../../../app/redux/actions';
import ModalQuizEvent from '../../../atoms/Modals/ModalQuizEvent';
import { EVENT_QUIZ_START } from '../../../../app/redux/actions/coursedetails';

const CourseSessions = ({
  mediaIsPhone,
  session,
  modalOpen,
  quizSessionStart,
}) => {
  return (
    <>
      <Text type="b3" mb={32}>
        Il completamento dell'evento sarà registrato a seguito della
        partecipazione alla sessione e all'effettivo superamento del quiz
        finale. Il solo superamento del quiz non è quindi sufficiente per il
        completamento dell'evento.
      </Text>
      {(session || []).map((sessionItem, si) => (
        <React.Fragment key={`session-${si}`}>
          {sessionItem?.session_name && (
            <Text type="h2" mb={16} className={si === 0 ? '' : 'main-title'}>
              {sessionItem?.session_name}
            </Text>
          )}
          {(sessionItem.activities || []).map((activity, ai) => (
            <div key={`section-${ai}`}>
              <SessionBox
                activity={activity}
                ai={ai}
                sessionId={sessionItem?.session_id}
              />
            </div>
          ))}
          {sessionItem?.session_quiz_id && (
            <QuizBox
              activity={sessionItem?.quiz_data}
              session={sessionItem}
              modalOpen={modalOpen}
              quizSessionStart={quizSessionStart}
            />
          )}
        </React.Fragment>
      ))}
      <ModalQuizEvent />
    </>
  );
};

CourseSessions.propTypes = {
  mediaIsPhone: PropTypes.bool,
  session: PropTypes.array.isRequired,
  modalOpen: PropTypes.func,
  quizSessionStart: PropTypes.func,
};

export default connect(
  (state) => {
    const { session = [] } = state.coursedetails;
    return {
      session,
    };
  },
  (dispatch) => ({
    modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    quizSessionStart: (id) => dispatch({ type: EVENT_QUIZ_START._REQUEST, id }),
  })
)(withMediaQueries(CourseSessions));
